import React from 'react';
import PropTypes from 'prop-types';

import CouponOfferComponent from './CouponOfferComponent';
import { CashbackOfferComponent } from './CashbackOfferComponent';
import PartnerBlockHorizontalComponent from '../../../partner/PartnerBlockHorizontalComponent';

import { ModalOfferContainer } from './ModalOfferComponentStyle';

export class ModalOfferComponent extends React.Component {
    renderConditionnalTitle(partner) {
        return partner && partner.name ? partner.name : '';
    }

    extractOrBlank(str) {
        return str ? ` ${str}` : '';
    }

    render() {
        const { partner, coupon, discount } = this.props;
        if (partner) {
            return (
                <ModalOfferContainer className="flex flex-h">
                    <PartnerBlockHorizontalComponent partner={partner} noLogoLink>
                        <CouponOfferComponent partner={partner} coupon={coupon} />
                        <CashbackOfferComponent
                            partner={partner}
                            withCoupon={coupon && coupon.id > 0}
                            discount={discount}
                        />
                    </PartnerBlockHorizontalComponent>
                </ModalOfferContainer>
            );
        }
        return null;
    }
}

ModalOfferComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    coupon: PropTypes.object,
    discount: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/ModalOfferComponent.js